export default __webpack_public_path__ + "static/media/bg_campeonato.566dae0b.webp";